import React from "react";
import { CheckIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { CountdownTimer } from "./CountdownTimer";
import { ScarcityBar } from "./ScarcityBar";
const mainSystems = [{
  name: "Sistema #1 · Instala tu Negocio de Reparaciones",
  value: "$97"
}, {
  name: "Sistema #2 · Cobra Como un Técnico Premium",
  value: "$67"
}, {
  name: "Sistema #3 · Reparaciones Sin Caos",
  value: "$67"
}, {
  name: "Sistema #4 · Clientes que Recomiendan",
  value: "$47"
}, {
  name: "Sistema #5 · Clientes Todos los Meses",
  value: "$67"
}, {
  name: "Sistema #6 · Negocio Listo para Operar",
  value: "$97"
}];
const freeBonuses = [{
  name: "🔧 Sistema Taller Productivo™",
  value: "$37"
}, {
  name: "💰 Sistema Compras Inteligentes™",
  value: "$47"
}, {
  name: "🛡️ Sistema Garantía Blindada™",
  value: "$47"
}, {
  name: "📈 Sistema Ganancia Real™",
  value: "$37"
}, {
  name: "📲 Sistema WhatsApp Vendedor™",
  value: "$67"
}];
function Row({
  name,
  value
}: {
  name: string;
  value: string;
}) {
  return <li className="flex items-center justify-between gap-3 border-b border-white/5 py-2.5 last:border-0" data-id="element-204" data-mp="1tgeh7tb2jcqk">
      <span className="flex items-start gap-2 text-sm text-white/85" data-id="element-205" data-mp="1ohl2xynyjhpc">
        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-emerald-400" data-id="element-206" data-mp="235o9b95wwveo" />
        {name}
      </span>
      <span className="shrink-0 font-display text-sm font-bold text-white/50 line-through" data-id="element-207" data-mp="1ye6b2sv9x8xe">
        {value}
      </span>
    </li>;
}
export function ValueStack() {
  return <section className="w-full bg-neutral-950 py-14" data-id="element-208" data-mp="284j5dcsw4ggq">
      <div className="mx-auto max-w-lg px-4" data-id="element-209" data-mp="283pt5wb5wyr7">
        <h2 className="text-center font-display text-2xl font-extrabold text-white sm:text-3xl" data-id="element-210" data-mp="2m3s8bas35e2r">
          💰 Todo lo que recibirás hoy
        </h2>

        <div className="mt-8 rounded-2xl border border-white/10 bg-neutral-900 p-5" data-id="element-211" data-mp="2h5gyv15pd5l2">
          <p className="font-display text-sm font-bold uppercase tracking-wide text-amber-400" data-id="element-212" data-mp="rqsn924xrro3">
            Sistema Técnico PRO 360™
          </p>
          <ul className="mt-2" data-id="element-213" data-mp="2mt5u0sr006sj">
            {mainSystems.map(s => <Row key={s.name} {...s} data-id="element-214" data-mp="2mv0e64ug3uvk" />)}
          </ul>

          <p className="mt-5 font-display text-sm font-bold uppercase tracking-wide text-amber-400" data-id="element-215" data-mp="2rtabakzqd5jt">
            Además recibirás GRATIS
          </p>
          <ul className="mt-2" data-id="element-216" data-mp="2vw6x0kkkhhrz">
            {freeBonuses.map(s => <Row key={s.name} {...s} data-id="element-217" data-mp="30u8hn9xn5p5k" />)}
          </ul>
        </div>

        {/* total value */}
        <div className="mt-6 overflow-hidden rounded-2xl border border-white/10" data-id="element-218" data-mp="35pxjxl11pk5k">
          <table className="w-full text-sm" data-id="element-219" data-mp="3apjvlq186sc9">
            <tbody data-id="element-220" data-mp="3fi3d2y31a7mc">
              <tr className="bg-neutral-900" data-id="element-221" data-mp="3fhl739qkkf18">
                <td className="px-4 py-3 text-white/80" data-id="element-222" data-mp="3fjxx8a6hdvpd">
                  Sistema Técnico PRO 360™
                </td>
                <td className="px-4 py-3 text-right font-display font-bold text-white/60 line-through" data-id="element-223" data-mp="3oijfs5bydaq5">
                  $442 USD
                </td>
              </tr>
              <tr className="bg-neutral-950" data-id="element-224" data-mp="3thw1unv02dro">
                <td className="px-4 py-3 text-white/80" data-id="element-225" data-mp="7gon6hi3eosl">5 Sistemas Premium</td>
                <td className="px-4 py-3 text-right font-display font-bold text-white/60 line-through" data-id="element-226" data-mp="2h28e3mm90ho">
                  $235 USD
                </td>
              </tr>
              <tr className="bg-amber-400/10" data-id="element-227" data-mp="3tnn5o539l4n5">
                <td className="px-4 py-3 font-display font-extrabold uppercase text-amber-300" data-id="element-228" data-mp="3pm9wpm4vklc0">
                  Valor total
                </td>
                <td className="px-4 py-3 text-right font-display text-lg font-extrabold text-amber-300 line-through decoration-red-500" data-id="element-229" data-mp="q5v5w4ivzgee">
                  $677 USD
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* price reveal */}
        <div className="mt-8 rounded-2xl border-2 border-amber-400/50 bg-neutral-900 p-6 text-center" data-id="element-230" data-mp="cegog24mnn9g">
          <p className="text-sm text-white/70" data-id="element-231" data-mp="18ypdgde6k68l">
            Pero hoy no pagarás $677 USD. Ni siquiera la mitad.
          </p>
          <p className="mt-3 text-xs uppercase tracking-widest text-white/50" data-id="element-232" data-mp="144bgi6jvdr1t">
            Hoy puedes obtener acceso inmediato por solo
          </p>
          <div className="mt-2 font-display text-5xl font-extrabold text-amber-400" data-id="element-233" data-mp="toixb4exyp5x">
            $15{" "}
            <span className="align-top text-lg text-white/60" data-id="element-234" data-mp="forl997zjiuk">USD</span>
          </div>
          <p className="mt-2 text-sm font-semibold text-white" data-id="element-235" data-mp="jojqbby676v6">
            Pago único · Sin mensualidades · Acceso de por vida
          </p>
          <p className="mt-1 text-xs text-white/50" data-id="element-236" data-mp="17fny49u1pnhu">
            💱 El cambio de moneda se aplica de forma automática según tu país.
          </p>

          <div className="mt-6" data-id="element-237" data-mp="yn3vkyamuyrq">
            <CtaButton label="Quiero acceso inmediato por $15" data-id="element-238" data-mp="ym2mgzd6gmcn" />
          </div>

          <div className="mt-5 rounded-xl border border-white/10 bg-white/[0.03] p-4" data-id="element-239" data-mp="12n4d4rt13q30">
            <CountdownTimer data-id="element-240" data-mp="1qdi56ibm5oxl" />
          </div>

          <ScarcityBar className="mt-4" data-id="element-241" data-mp="1qbnkn5497yu1" />
        </div>
      </div>
    </section>;
}